var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPersonalityDisorder(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 53.49 59.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: none;\r\n        stroke: #805aed;\r\n        stroke-linecap: round;\r\n        stroke-linejoin: round;\r\n        stroke-width: 1.5px;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M33.79,58.75H8.47v-18.12C3.73,36.43.75,30.38.75,23.66.75,11,11.27.75,24.24.75s23.47,10.25,23.47,22.91c0,.87-.05,1.74-.15,2.6-.05.43.03.86.24,1.23l4.71,8.26c.57.98,0,2.21-1.1,2.45l-4.84,1v7.84c0,1.35-1.1,2.45-2.47,2.45h-10.33"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M25.52,45.09l1.68,1.67c1.74,1.74,4.11,2.72,6.58,2.72"
  })), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "35.8 49.48 35.8 58.75 32.64 58.75"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M11.05,10.46c8.58-1.28,17.52.03,25.38,3.71,2.71,1.27,5.64,3.26,4.7,6.94-.23.89-.69,1.7-1.23,2.44-5.51,7.56-17.81,11.24-24.53,4.61-4.26-4.2-2.39-11.98,1.71-15.44,2.91-2.46,7.39-.32,7.29,3.49-.16,6.28-1.72,12.52-4.52,18.13-1.62,3.24-6.2,3.66-8.34.74-2.91-3.97-3.39-10.17-.35-14.29,4.49-6.1,13.91-6.94,20.37-3.06,3.28,1.97,5.85,4.88,7.72,8.25,2.56,4.61-2.94,9.61-7.32,6.66-7.23-4.88-12.18-13.47-12.27-22.23-.04-3.63,3.69-6.29,7.02-4.86,5.15,2.22,8.98,9.23,7.65,15.27-1.25,5.67-5.07,10.11-9.59,13.9-3.43,2.88-8.61,1.85-10.67-2.15l-4.98-9.7c-1.76-3.44-.43-7.65,2.99-9.45l1.65-.87"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonalityDisorder);
export default __webpack_public_path__ + "static/media/personality-disorder.f544e0d74b5b4052be1433d0f0af09dd.svg";
export { ForwardRef as ReactComponent };